import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Img from "gatsby-image";
import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import Box from "@material-ui/core/Box";
import { withStyles } from "@material-ui/core/styles";
import ChatBubbles from "./ChatBubbles";

const MainContainer = withStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection:"column",
        width: "100%",
        marginLeft: "-60px",
        marginTop: "15px",
        marginBottom: "30px",
        "& .MuiBadge-colorPrimary": {
            backgroundColor: "#16C686",
        },

        [theme.breakpoints.down(550)]: {
            marginLeft: "0",
        },
    },
}))(Box);
const TopContainer = withStyles({
    root: {
        display: "flex",
        flexDirection:"row",
        width: "100%",
        height: "fit-content",
    },
})(Box);
const BottomContainer = withStyles({
    root: {
        display: "flex",
        flexDirection:"row",
        width: "calc(100% - 60px)",
        marginLeft: "60px",
    },
})(Box);
const MessageContainer = withStyles({
    root: {
        display: "flex",
        flexDirection:"column",
        width: "100%",
        marginTop: "-15px",
    },
})(Box);
const ChatBotAvatar = withStyles({
    root: {
        width: "50px",
        height: "50px",
    },
    colorDefault: {
        backgroundColor: "transparent",
    },
})(Avatar);
const ChatBotName = withStyles((theme) => ({
    root: {
        ...theme.typography.h6,
        fontWeight: 700,
        width: "100%",
        paddingLeft: "6px",
        paddingTop: "8px",
    },
}))(Box);
const ChatBotOnlineStatus = withStyles({
    root: {
        margin: "5px",
    },
})(Badge);

const ChatBot = ({
    agentName,
    messages,
    hasTypingIndicator,
}) => {
    const imageData = useStaticQuery(imageQuery);
    const fragmentProps = imageData.avatarImage.childImageSharp.fixed;
    // const avatarImgSrcWebp = fragmentProps.srcWebp;
    // const avatarImgSrcSetWebp = fragmentProps.srcSetWebp;

    return (
        <MainContainer>
            <TopContainer>
                <Box>
                    <ChatBotOnlineStatus
                        overlap="circle"
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                        }}
                        variant="dot"
                        color="primary"
                        badgeContent=""
                    >
                        <ChatBotAvatar>
                            <Img
                                fixed={fragmentProps}
                                fadeIn={false}
                                loading="eager"
                            />
                        </ChatBotAvatar>
                    </ChatBotOnlineStatus>
                </Box>
                <ChatBotName>{agentName}</ChatBotName>
            </TopContainer>
            <BottomContainer>
                <MessageContainer>
                    <ChatBubbles
                        messages={messages}
                        hasTypingIndicator={hasTypingIndicator}
                    />
                </MessageContainer>
            </BottomContainer>
        </MainContainer>
    );
};

export default ChatBot;

export const imageQuery = graphql`
    {
        avatarImage: file(relativePath: { eq: "avatar.png" }){
            childImageSharp{
                fixed(width: 50, quality: 90){
                    ...GatsbyImageSharpFixed_withWebp_noBase64
                }
            }
        }
    }
`;